import Panel from '@/finsight/ui/components/static/Company/Panel';
import CustomersLogos from './CustomersLogos';
import finsightLogoText from '@/Framework/assets/logo/finsightLogoText.inline.svg';

import { clearfixStyles } from '@dealroadshow/uikit/core/components/Clearfix';
import aboutUsStyles from '../aboutUs.scss';

const trustedBySubtitles = [
  `FINSIGHT creates high-reliability financial technology that provides unparalleled visibility and actionable insights
  into capital markets. We are a New York City-based company serving thousands of the leading institutional investors,
  investment banks and corporations across the globe.`,
  `Our applications streamline workflows that facilitate hundreds of billions of dollars worth of capital markets
  activity.`,
];

const Customers = () => (
  <Panel
    classNameWrapper={ clearfixStyles.clearfix }
    title="Illuminating capital markets"
    subTitles={ trustedBySubtitles }
  >
    <div className={ aboutUsStyles.contentHolder }>
      <CustomersLogos />
      <div
        className={ aboutUsStyles.companyName }
        dangerouslySetInnerHTML={ { __html: finsightLogoText } }
      />
      <div className={ aboutUsStyles.backgroundWallStreet } />
    </div>
  </Panel>
);

export default Customers;
